"use client";

import dynamic from "next/dynamic";

const NotFoundView = dynamic(
  () => import("@/components/not-found-view").then((mod) => mod.NotFoundView),
  { ssr: false },
);

export function NotFoundLoader() {
  return <NotFoundView />;
}
